import { render, staticRenderFns } from "./PcNews2.vue?vue&type=template&id=7f11ddd8&scoped=true"
import script from "./PcNews2.vue?vue&type=script&lang=js"
export * from "./PcNews2.vue?vue&type=script&lang=js"
import style0 from "./PcNews2.vue?vue&type=style&index=0&id=7f11ddd8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f11ddd8",
  null
  
)

export default component.exports